var React = require('react');

function AngleRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.388 2.232a.988.988 0 0 0-1.398.127 1.004 1.004 0 0 0 .126 1.409l5.033 4.229-5.042 4.235a1.005 1.005 0 0 0-.126 1.409.985.985 0 0 0 1.398.127l6.871-5.771-6.862-5.765z"}));
}

AngleRight.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = AngleRight;

AngleRight.default = AngleRight;
